import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUIStore } from '@/core/stores/ui.store'

export function useSidebarState() {
  const router = useRouter()
  const route = useRoute()
  const uiStore = useUIStore()
  const { sidebarCollapsed } = storeToRefs(uiStore)
  const { setSidebarCollapsed } = uiStore

  const expandedKeys = ref({})
  const menuItems = ref([])

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed.value)
  }

  const toggleItem = (key) => {
    expandedKeys.value[key] = !expandedKeys.value[key]
  }

  const handleItemClick = (item) => {
    if (item.hasChildren) {
      if (sidebarCollapsed.value) {
        setSidebarCollapsed(false)
        expandedKeys.value[item.key] = true
      }
      else {
        toggleItem(item.key)
      }
    }
    else if (item.route) {
      router.push(item.route).catch(() => {})
    }
  }

  const isItemActive = (item) => {
    if (!item.route)
      return false

    if (item.hasChildren)
      return false

    if (typeof item.route === 'object') {
      return (
        route.name === item.route.name
        && route.params.dashboardId === item.route.params?.dashboardId
      )
    }

    return route.path === item.route
  }

  const hasActiveChild = (item) => {
    if (!item.children || item.children.length === 0)
      return false

    return item.children.some((child) => {
      if (isItemActive(child))
        return true
      if (child.children && child.children.length > 0)
        return hasActiveChild(child)
      return false
    })
  }

  const findAndExpandActiveItem = (items) => {
    if (!items || items.length === 0)
      return

    items.forEach((item) => {
      if (item.children && item.children.length > 0) {
        const hasActiveChild = item.children.some((child) => {
          if (child.children) {
            return findAndExpandActiveItem([child])
          }
          return isItemActive(child)
        })

        if (hasActiveChild) {
          expandedKeys.value[item.key] = true
        }

        findAndExpandActiveItem(item.children)
      }
    })
  }

  const setMenuItems = (items) => {
    menuItems.value = items
    findAndExpandActiveItem(items)
  }

  watch(
    () => route.path,
    () => {
      findAndExpandActiveItem(menuItems.value)
    },
  )

  return {
    collapsed: sidebarCollapsed,
    expandedKeys,
    toggleSidebar,
    setSidebarCollapsed,
    handleItemClick,
    isItemActive,
    hasActiveChild,
    setMenuItems,
  }
}
